import { Component } from '@angular/core';
import {AlertController, NavController} from 'ionic-angular';
import {AngularFire, FirebaseListObservable} from 'angularfire2';

import {ThemeService, AuthService} from '../../../providers/index';

@Component({
  selector: 'page-resident-summary',
  templateUrl: 'resident-summary.html'
})
export class ResidentSummaryPage {

  residentList: FirebaseListObservable<any>;
  project: string;

  constructor(public navCtrl: NavController, public af: AngularFire, private _auth: AuthService,
              public alertCtrl: AlertController, private _theme: ThemeService) {
    this.residentList = af.database.list('/residents');
    console.log('Theme: ' + this._theme.getNameOfTheme());

    this.project = this._theme.getNameOfTheme();
  }

  promptResidentApproval(residentId: string) {
    let alert = this.alertCtrl.create({
      message: "Mark as correct?",
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Mark as Correct',
          handler: data => {
            this.residentList.update(residentId, { approved: true });
          }
        }
      ]
    });
    alert.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResidentSummaryPage');
    //might need to do this: https://www.joshmorony.com/creating-role-based-authentication-with-passport-in-ionic-2-part-2/login-page.ts
  }

  ionViewCanEnter(): boolean {
    if(this._auth.authenticated){
      return true;
    } else {
      return false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/resident/resident-summary/resident-summary.ts